/*###########################################################################
// Header
//#########################################################################*/

import { inViewport } from '../utilities/_inViewport'
import { throttle } from '../utilities/_throttleDebounce'

export default function header() {
	return {
		config: {
			main: 'main',
			header: '.header',
			headerBackdrop: '.header__backdrop',
			headerNav: '.header__nav',
			headerMenuBtn: '.header__menu-btn',
			headerSubMenu: '.header__submenu',
			headerSubMenuSingle: '.header__submenu--single',
			headerSubMenuTrigger: '.header__nav__item--sub',
			heroHome: '.heroHome'
		},

		elements: {},

		state: {
			isMobile: false,
			dropdownOpen: false
		},

		breakpoint: 1024,

		init() {
			const self = this

			self.elements.header = document.querySelector(self.config.header)

			if (self.elements.header !== null) {
				self.elements.main = document.querySelector(self.config.main)
				self.elements.headerBackdrop = self.elements.header.querySelector(self.config.headerBackdrop)
				self.elements.headerNav = self.elements.header.querySelector(self.config.headerNav)
				self.elements.headerMenuBtn = self.elements.header.querySelectorAll(self.config.headerMenuBtn)
				self.elements.headerSubMenus = self.elements.header.querySelectorAll(self.config.headerSubMenu)
				self.elements.headerSubMenuTriggers = self.elements.header.querySelectorAll(self.config.headerSubMenuTrigger)
				self.elements.heroHome = document.querySelector(self.config.heroHome)

				// Handle scroll
				//
				self.handleScroll()

				// Handle backdrop
				//
				self.handleBackdropClick()

				// Handle menu btn
				//
				self.handleMenuBtn()

				// Handle sub menu items
				//
				self.handleSubMenuItems()

				// Handle sub menu singles
				//
				setTimeout(function () {
					self.handleSubMenus()
				}, 500)

				// Set nav height
				//
				if (window.innerWidth < self.breakpoint) {
					self.setNavHeight()

					self.state.isMobile = true
				} else {
					self.state.isMobile = false
				}

				window.addEventListener('resize', throttle(function () {
					if (window.innerWidth < self.breakpoint) {
						self.setNavHeight()

						self.state.isMobile = true
					} else {
						self.unsetNavHeight()

						if (self.state.isMobile === true) {
							self.resetMenuState()
						}

						self.state.isMobile = false
					}

					self.handleSubMenus()
				}, 250))

				// Reset menu on page change (barba)
				//
				window.addEventListener('before-page-change', function () {
					self.resetMenuState()
				})
			}
		},

		handleScroll() {
			const self = this

			let scrollPosition = window.pageYOffset || document.documentElement.scrollTop
			let scrollTransitionPoint = 20

			// Adjust scroll transition point based if on homepage vs other pages
			//

			window.addEventListener('heroHomeInitialised', function () {
				setTimeout(() => {
					if (self.elements.heroHome !== null) {
						scrollTransitionPoint = self.elements.heroHome.clientHeight * 2
					}
				}, 250)
			})

			window.addEventListener('page-change', function () {
				setTimeout(() => {
					self.elements.heroHome = document.querySelector(self.config.heroHome)

					if (self.elements.heroHome === null) {
						scrollTransitionPoint = 20
					} else {
						scrollTransitionPoint = self.elements.heroHome.clientHeight * 2
					}
				}, 1250)
			})

			// Initial check
			//
			if (scrollPosition > scrollTransitionPoint) {
				self.elements.main.classList.add('header--scrolled')
				self.elements.header.classList.add('header--scrolled')

				setTimeout(function () {
					self.handleSubMenus()
				}, 500)
			} else {
				self.elements.main.classList.remove('header--scrolled')
				self.elements.header.classList.remove('header--scrolled')

				setTimeout(function () {
					self.handleSubMenus()
				}, 500)
			}

			setTimeout(function () {
				// Set nav height
				//
				if (window.innerWidth < self.breakpoint) {
					self.setNavHeight()
				}
			}, 1000)

			let lastScrollTop = 0
			let isScrolled = false
			let hideTriggerAmount = window.innerWidth > 1440 ? 40 : 20

			window.addEventListener('scroll', throttle(function () {
				scrollPosition = window.scrollY || document.documentElement.scrollTop

				if (scrollPosition > scrollTransitionPoint) {
					self.elements.main.classList.add('header--scrolled')
					self.elements.header.classList.add('header--scrolled')

					if (isScrolled === false) {
						setTimeout(function () {
							self.handleSubMenus()
						}, 500)

						isScrolled = true
					}
				} else {
					self.elements.main.classList.remove('header--scrolled')
					self.elements.header.classList.remove('header--scrolled')

					if (isScrolled === true) {
						setTimeout(function () {
							self.handleSubMenus()
						}, 500)

						isScrolled = false
					}
				}

				if (inViewport(document.querySelector('.approach'), window.innerHeight / 4) && scrollPosition > hideTriggerAmount) {
					self.elements.main.classList.add('header--scrolled')
					self.elements.header.classList.add('header--scrolled')
					self.elements.header.classList.remove('header--scrolling-up')
				} else if (scrollPosition > hideTriggerAmount) {
					if (lastScrollTop > scrollPosition) {
						self.elements.header.classList.add('header--scrolling-up')
					} else {
						self.elements.header.classList.remove('header--scrolling-up')
					}
				} else {
					self.elements.header.classList.remove('header--scrolling-up')
				}
				lastScrollTop = scrollPosition <= 0 ? 0 : scrollPosition

				setTimeout(function () {
					// Set nav height
					//
					if (window.innerWidth < self.breakpoint) {
						self.setNavHeight()
					}
				}, 500)
			}, 250))
		},

		setNavHeight() {
			const self = this

			self.elements.headerNav.style.height = (window.innerHeight - (self.elements.header.clientHeight)) + "px"
		},

		unsetNavHeight() {
			const self = this

			self.elements.headerNav.style.height = ""
		},

		handleMenuBtn() {
			const self = this

			for (let i = 0; i < self.elements.headerMenuBtn.length; i++) {
				const headerMenuBtn = self.elements.headerMenuBtn[i]
				const headerMenuBtnText = headerMenuBtn.querySelector('.header__menu-btn__text')

				headerMenuBtn.addEventListener('click', function (e) {
					e.preventDefault()

					if (self.elements.header.classList.contains('header--open')) {
						self.elements.header.classList.remove('header--open')
						self.elements.headerBackdrop.classList.remove('header__backdrop--active')

						window.app.enableScroll()
						window.lenis.start()

						// Reset sub menus
						//
						setTimeout(function () {
							for (let i = 0; i < self.elements.headerSubMenuTriggers.length; i++) {
								const headerSubMenuTrigger = self.elements.headerSubMenuTriggers[i]
								headerSubMenuTrigger.classList.remove('header__nav__item--active')
							}

							// Remove potential classes
							//
							self.elements.header.classList.remove('header--sub-open')
							self.elements.headerNav.classList.remove('overflow-hidden')

							// Reset nav scroll
							//
							self.elements.headerNav.scrollTop = 0

							// Reset nav overflow
							//
							self.elements.headerNav.style.overflowY = ''
						}, 500)

						// Handle menu btn text
						//
						if (headerMenuBtnText !== null) {
							headerMenuBtnText.innerHTML = headerMenuBtnText.getAttribute('data-inactive-text')
						}
					} else {
						// Reset sub menus
						//
						for (let i = 0; i < self.elements.headerSubMenuTriggers.length; i++) {
							const headerSubMenuTrigger = self.elements.headerSubMenuTriggers[i]
							headerSubMenuTrigger.classList.remove('header__nav__item--active')
						}

						self.elements.header.classList.add('header--open')
						self.elements.headerBackdrop.classList.add('header__backdrop--active')

						window.app.disableScroll()
						window.lenis.stop()

						// Handle menu btn text
						//
						if (headerMenuBtnText !== null) {
							headerMenuBtnText.innerHTML = headerMenuBtnText.getAttribute('data-active-text')
						}
					}
				})
			}
		},

		isScrollable(element) {
			const self = this

			if (element.scrollHeight > element.clientHeight) {
				return true
			}
		},

		resetMenuState() {
			const self = this

			self.elements.header.classList.remove('header--open')
			window.app.enableScroll()

			// Reset sub menus
			//
			setTimeout(function () {
				for (let i = 0; i < self.elements.headerSubMenuTriggers.length; i++) {
					const headerSubMenuTrigger = self.elements.headerSubMenuTriggers[i]
					const headerSubMenu = headerSubMenuTrigger.nextElementSibling
					headerSubMenu.classList.remove('header__submenu--open')
					headerSubMenu.scrollTop = 0
					self.setSubMenuTabIndexes(headerSubMenu, false)
				}

				// Remove potential classes
				//
				self.elements.header.classList.remove('header--sub-open')
				self.elements.headerNav.classList.remove('overflow-hidden')

				// Reset nav scroll
				//
				self.elements.headerNav.scrollTop = 0

				// Reset dropdowns
				//
				if (self.elements.headerNav.querySelector('.header__nav__item--active') !== null) {
					self.elements.headerNav.querySelector('.header__nav__item--active').classList.remove('header__nav__item--active')
				}

				self.elements.headerBackdrop.classList.remove('header__backdrop--active')

				// Reset nav overflow
				self.elements.headerNav.style.overflowY = ''
			}, 500)
		},

		handleSubMenuItems() {
			const self = this
			const hoverCloseDelay = 300

			for (let k = 0; k < self.elements.headerSubMenuTriggers.length; k++) {
				const headerSubMenuTrigger = self.elements.headerSubMenuTriggers[k]

				if (headerSubMenuTrigger.nextElementSibling !== null) {
					const headerSubMenu = headerSubMenuTrigger.nextElementSibling
					let closeTimeout = null

					headerSubMenuTrigger.addEventListener('keyup', function (e) {
						if (e.key === 'Enter' || e.keyCode === 13) {
							headerSubMenuTrigger.click()
						}
					})

					headerSubMenuTrigger.addEventListener('mouseenter', function () {
						if (window.innerWidth >= self.breakpoint) {
							clearTimeout(closeTimeout)

							if (!headerSubMenuTrigger.classList.contains('header__nav__item--active')) {
								headerSubMenuTrigger.click()
							}
						}
					})

					headerSubMenuTrigger.addEventListener('mouseleave', function () {
						if (window.innerWidth >= self.breakpoint) {
							clearTimeout(closeTimeout)

							closeTimeout = setTimeout(function () {
								if (headerSubMenuTrigger.classList.contains('header__nav__item--active')) {
									headerSubMenuTrigger.click()
								}
							}, hoverCloseDelay)
						}
					})

					headerSubMenu.addEventListener('mouseenter', function () {
						if (window.innerWidth >= self.breakpoint) {
							clearTimeout(closeTimeout)
						}
					})

					headerSubMenu.addEventListener('mouseleave', function () {
						if (window.innerWidth >= self.breakpoint) {
							clearTimeout(closeTimeout)

							closeTimeout = setTimeout(function () {
								if (headerSubMenuTrigger.classList.contains('header__nav__item--active')) {
									headerSubMenuTrigger.click()
								}
							}, hoverCloseDelay)
						}
					})

					headerSubMenuTrigger.addEventListener('click', function () {
						// Remove current active dropdown
						//
						if (headerSubMenuTrigger !== self.elements.headerNav.querySelector('.header__nav__item--active')) {
							if (self.elements.headerNav.querySelector('.header__nav__item--active') !== null) {
								self.elements.headerNav.querySelector('.header__nav__item--active').classList.remove('header__nav__item--active')

								if (self.elements.headerNav.querySelector('.header__submenu--open') !== null) {
									self.elements.headerNav.querySelector('.header__submenu--open').classList.remove('header__submenu--open')
								}

								self.setSubMenuTabIndexes(headerSubMenu, false)
							}
						}

						// Handle mobile and desktop states
						//
						if (window.innerWidth < self.breakpoint) {
							if (!headerSubMenu.classList.contains('header__submenu--open')) {
								headerSubMenuTrigger.classList.add('header__nav__item--active')
								headerSubMenu.classList.add('header__submenu--open')
								self.elements.header.classList.add('header--sub-open')
								self.elements.headerNav.scrollTop = 0
								headerSubMenu.scrollTop = 0
							} else {
								headerSubMenuTrigger.classList.remove('header__nav__item--active')
								headerSubMenu.classList.remove('header__submenu--open')
								self.elements.header.classList.remove('header--sub-open')
								self.elements.headerNav.scrollTop = 0
								headerSubMenu.scrollTop = 0
							}
						} else {
							// Toggle active dropdown
							//
							if (headerSubMenuTrigger.classList.contains('header__nav__item--active')) {
								self.elements.header.classList.remove('header--sub-open')
								headerSubMenuTrigger.classList.remove('header__nav__item--active')
								self.setSubMenuTabIndexes(headerSubMenu, false)
								self.elements.headerBackdrop.classList.remove('header__backdrop--active')
							} else {
								self.elements.header.classList.add('header--sub-open')
								headerSubMenuTrigger.classList.add('header__nav__item--active')
								self.elements.headerBackdrop.classList.add('header__backdrop--active')

								// On opening a dropdown, ensure all submenu tab indexes are reset
								//
								for (let h = 0; h < self.elements.headerSubMenuTriggers.length; h++) {
									const headerSubMenuTrigger = self.elements.headerSubMenuTriggers[h]

									if (headerSubMenuTrigger.nextElementSibling !== null) {
										const headerSubMenu = headerSubMenuTrigger.nextElementSibling

										self.setSubMenuTabIndexes(headerSubMenu, false)
									}
								}

								// Set tab indexes
								//
								self.setSubMenuTabIndexes(headerSubMenu, true)
							}
						}
					})
				}
			}
		},

		handleSubMenus() {
			const self = this

			if (self.elements.headerSubMenus !== null && window.innerWidth >= self.breakpoint) {
				for (let i = 0; i < self.elements.headerSubMenus.length; i++) {
					const headerSubMenu = self.elements.headerSubMenus[i]
					const parentNavItem = headerSubMenu.previousElementSibling
					const leftPosition = parentNavItem.offsetLeft + (parentNavItem.getBoundingClientRect().width / 2)

					headerSubMenu.style.left = leftPosition + 'px'

					if (headerSubMenu.getBoundingClientRect().left < 0) {
						headerSubMenu.style.left = leftPosition + (Math.abs(headerSubMenu.getBoundingClientRect().left) + 20) + 'px'
					} else if (headerSubMenu.getBoundingClientRect().right > window.innerWidth) {
						headerSubMenu.style.left = leftPosition - (headerSubMenu.getBoundingClientRect().right - window.innerWidth + 20) + 'px'
					}
				}
			} else {
				for (let i = 0; i < self.elements.headerSubMenus.length; i++) {
					const headerSubMenu = self.elements.headerSubMenus[i]
					headerSubMenu.style.left = ''
				}
			}
		},

		setMenuDropdownPosition(subMenu) {
			if (window.innerWidth >= 1024) {
				if (subMenu.getBoundingClientRect().left < 0) {
					subMenu.style.transform = 'translateX(-50%) translateX(+' + (Math.abs(subMenu.getBoundingClientRect().left) + 20) + 'px)'
				} else if (subMenu.getBoundingClientRect().right > window.innerWidth) {
					subMenu.style.transform = 'translateX(-50%) translateX(-' + (subMenu.getBoundingClientRect().right - window.innerWidth + 20) + 'px)'
				}
			} else {
				subMenu.style.transform = ''
			}
		},

		setSubMenuTabIndexes(headerSubMenu, isFocusable) {
			const self = this

			const focusableElements = headerSubMenu.querySelectorAll('a, button')

			for (let i = 0; i < focusableElements.length; i++) {
				const focusableElement = focusableElements[i]

				if (isFocusable === true) {
					focusableElement.tabIndex = '0'
				} else {
					focusableElement.tabIndex = '-1'
				}
			}
		},

		handleBackdropClick() {
			const self = this

			self.elements.headerBackdrop.addEventListener('click', function () {
				if (window.innerWidth > self.breakpoint) {
					self.elements.header.classList.remove('header--open')
					self.elements.header.classList.remove('header--sub-open')
					self.elements.headerBackdrop.classList.remove('header__backdrop--active')

					window.app.enableScroll()
					window.lenis.start()

					if (self.elements.headerNav.querySelector('.header__nav__item--active') !== null) {
						self.elements.headerNav.querySelector('.header__nav__item--active').classList.remove('header__nav__item--active')
					}
				}
			})
		}
	}
}
